import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {getOutageData} from "../../../../../store/reducers/outage";
import {IOutage} from "../../../../../data/data";
import HighlightText from "../../../../common/highlight-text/HighlightText";

interface OutageProps
{
    outage: IOutage;
}

import './Outage.scss';


class Outage extends React.Component<OutageProps, null>
{
    constructor(public props: OutageProps)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {outage} = this.props;
        const {title, affects, description} = outage;

        return <div styleName={'outage-content'}>

            <div styleName={'header'}>

                <div styleName={'image'}>

                    <img
                        styleName={'source-image'}
                        src={`./img/game/power-sources/${affects}@2x.png`} />
                    {/*<img*/}
                        {/*styleName={'warning-icon'}*/}
                        {/*src={`./img/game/modals/warning-icon@2x.png`} />*/}

                </div>

            </div>

            <div styleName={'text-column'}>

                <HighlightText type={'yellow'}>action needed</HighlightText>

                <h4 styleName={'headline'}>{title}</h4>

                <p styleName={'body-copy'}>{description}</p>

            </div>

        </div>;
    }
}



/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
        outage: getOutageData(state),
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Outage);


// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/outage/Outage.tsx